const url = {
    //发送验证码
    sendSmsCode: '/login/requestVerifyCode',
    //登录
    loginSignIn: '/login/signIn',
    //用户最近一次借贷申请
    latest: '/application/latest',
    //绑定的银行卡列表
    cardMemberList: '/repayment/cardMemberList',
    //绑定银行卡
    bindBankCard: '/basisInfo/bindBankCard',
    //send Pin
    sendPin: '/repayment/sendPin',
    //发送otp
    sendOpt: '/repayment/sendOpt',
    //银行卡支付
    cardRepayment: '/repayment/cardAuthRepayment',
    //获取ussd支持的银行
    getUSSDBankList: '/repayment/ussdBankList',
    //获取ussd支付信息
    getUSSDRepayment: '/repayment/ussdRepayment',
    //获取虚拟账户
    getVirtualAccount: '/repayment/vaAccount',
    //获取二维码支付信息
    getQrRepayment: '/repayment/qrRepayment',
    //获取配置开关
    getAppConfigType: '/systemConfig/appConfigType',
    // 数据字典
    findDictInfo:'/dict/findDictInfo'
}


export default url